import styled from 'styled-components';
import { lightGrey2Color } from 'js/config/style';

export default styled.div`
  font-size: 0.8rem;
  border-top: 1px solid ${lightGrey2Color};
  text-align: center;
  padding: 0.25rem 0;
  cursor: pointer;
  color: ${lightGrey2Color};
  user-select: none;

  &:hover {
    color: ${lightGrey2Color.darken()};
  }
  &:active {
    color: black;
  }
`;
